

































































































































































































































import draggable from "vuedraggable";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import factions from "@/config/wow/factions";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { getTimeSince } from "@/utils/date-helpers";

import { userDiscordLogin, discordDisconnect } from "@/utils/auth";

/**
 * Components
 */
import ClaimCharacterDialog from "./components/ClaimCharacterDialog.vue";
import TransferCharacterDialog from "./components/TransferCharacterDialog.vue";
import DeleteCharacterDialog from "./components/DeleteCharacterDialog.vue";

/**
 * API
 */
import usersAPI from "@/api/users";
import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * Types
 */

/**
 * VueX Modules
 */
const profileModule = namespace("profile");

interface DraggableEvent {
	oldIndex: number;
	newIndex: number;
}

/**
 * Profile page.
 */
@Component({
	components: {
		DataFetcher,
		ClaimCharacterDialog,
		TransferCharacterDialog,
		DeleteCharacterDialog,
		draggable
	}
})
export default class ProfilePage extends Vue {
	$refs!: {
		claimCharacterDialog: ClaimCharacterDialog;
		transferCharacterDialog: TransferCharacterDialog;
		deleteCharacterDialog: DeleteCharacterDialog;
	};

	/// Injections
	classes = classes;
	factions = factions;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;

	getTimeSince = getTimeSince;

	/// Properties

	/// Attributes
	isLoading = false;
	isDragging = false;

	/// VueX Modules
	@profileModule.Action("fetchCharacters")
	fetchCharacters: any;

	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;

	timeoutHandle: ReturnType<typeof setTimeout> | null = null;

	get characters(): GetCurrentUserResponse.Character[] {
		return this.userDetails.characters;
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.getCharacters();
		if (this.characters.find(x => x.isSynchronizing)) {
			this.startRegularFetching();
		}
	}

	beforeDestroy() {
		this.stopRegularFetching();
	}

	startRegularFetching() {
		const that = this;
		this.stopRegularFetching();
		this.timeoutHandle = setTimeout(async function () {
			await that.getCharacters();
			that.startRegularFetching();
		}, 4000);
	}

	stopRegularFetching() {
		if (this.timeoutHandle) {
			clearTimeout(this.timeoutHandle);
		}
	}

	async getCharacters() {
		await this.fetchCharacters();
	}

	async handleSynchronizeCharactersClick() {
		this.isLoading = true;
		try {
			await usersAPI.syncCharacters();
			await this.getCharacters();
			if (this.characters.find(x => x.isSynchronizing)) {
				this.startRegularFetching();
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleOpenClaimCharacterClick() {
		await this.$refs.claimCharacterDialog.open();
	}

	// async handleOpenTransferCharacterClick(character: any) {
	// 	//await this.$refs.transferCharacterDialog.open(character);
	// }

	async handleOpenDeleteCharacterClick(character: any) {
		await this.$refs.deleteCharacterDialog.open(character);
	}

	async handleAfterClaimCharacter() {
		await this.getCharacters();
	}

	async handleAfterTransferCharacter() {
		//await this.getCharacters();
	}

	async handleAfterDeleteCharacter() {
		await this.getCharacters();
	}

	async handleToggleCharacterVisibilityClick(characterID: any) {
		this.isLoading = true;
		try {
			await usersAPI.toggleCharacterVisibility(characterID);
			await this.getCharacters();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleLoginDiscord() {
		this.isLoading = true;
		try {
			await userDiscordLogin(this.$router);
		} catch (err) {
			this.handleAPIError(err);
			this.isLoading = false;
		}
	}

	async handleDisconnectDiscord() {
		if (!window.confirm(this.$t("user.alert_remove_connection").toString())) {
			return;
		}

		this.isLoading = true;
		try {
			await discordDisconnect();
		} catch (err) {
			this.handleAPIError(err);
			this.isLoading = false;
		}
	}

	async handleDragEnd(evt: DraggableEvent) {
		const oldIndex = evt.oldIndex;
		const newIndex = evt.newIndex;
		if (oldIndex == newIndex) {
			return;
		}

		const characterToMove = this.characters[newIndex];
		const newPosition = newIndex + 1;

		this.isDragging = false;

		this.isLoading = true;
		try {
			await usersAPI.changeCharacterOrder(characterToMove.id, newPosition);
		} catch (error) {
			this.handleAPIError(error);
		}

		try {
			await this.getCharacters();
		} catch (error) {
			this.handleAPIError(error);
		}

		this.isLoading = false;
	}
}
